<template>
  <tr class="competitor-tr">
    <template v-for="(field, fieldIndex) in item.fields" :key="fieldIndex">
      <template v-if="fieldIndex === 0">
        <td v-if="displayCheckbox" :key="fieldIndex" class="u-nowrap table-head">
          <div class="table-container">
            <ul class="c-checkbox">
              <li class="c-checkbox__item">
                <input
                  :id="'searchItems' + itemIndex"
                  v-model="innerSearchItems"
                  type="checkbox"
                  class="c-checkbox__input"
                  :value="formatGraphId(item)"
                  :disabled="hasMaxSelectableXAxesNum() && maxSelectableXAxesNum !== 1 && innerSearchItems.length >= maxSelectableXAxesNum && !innerSearchItems.find(i => i === item)"
                >
                <label class="c-checkbox__label competitor-tr__name-box" :for="'searchItems' + itemIndex">
                  <span v-if="showTableRowIndex" class="index-number" />
                  <p class="competitor-tr__name">
                    {{ formatFieldName(field.name) }}
                    <StoresCount v-if="item.fields.length === 1 && !!item.competitorNames" :store-names="item.competitorNames" :is-competitor="true" @open-modal="$emit('open-modal', item.competitorNames)" />
                  </p>
                  <p class="competitor-badge">競合</p>
                </label>
              </li>
            </ul>
            <router-link
              v-if="showReviewLink && item.fields.length === 1 && itemIndex !== 'display0' && !hideReviewLinkForSpecificItem"
              :to="{
                name: 'CompaniesCompetitorsReviews',
                params: {
                  company_uuid: companyUuid,
                },
                query: {
                  analysis_type: adaptKey(item.fields[0].key),
                  analysis_id: adaptId(item.fields[0]),
                }
              }"
              class="review-link"
            >
              <KkIcon name="review" color="#D2D5DB" />
            </router-link>
          </div>
        </td>
        <td v-else class="table-head">
          <div class="table-container">
            <div class="competitor-tr__name-box">
              <p class="competitor-tr__name">
                <span v-if="showTableRowIndex" class="index-number" />
                {{ formatFieldName(field.name) }}
                <StoresCount v-if="item.fields.length === 1 && !!item.competitorNames && !!item.competitorNames.length" :store-names="item.competitorNames" :is-competitor="true" @open-modal="$emit('open-modal', item.competitorNames)" />
              </p>
              <p class="competitor-badge">競合</p>
            </div>
            <router-link
              v-if="showReviewLink && item.fields.length === 1 && itemIndex !== 'display0' && !hideReviewLinkForSpecificItem"
              :to="{
                name: 'CompaniesCompetitorsReviews',
                params: {
                  company_uuid: companyUuid,
                },
                query: {
                  analysis_type: adaptKey(item.fields[0].key),
                  analysis_id: adaptId(item.fields[0]),
                }
              }"
              class="review-link"
            >
              <KkIcon name="review" color="#D2D5DB" />
            </router-link>
          </div>
        </td>
      </template>
      <td v-else :key="fieldIndex" class="table-head">
        <div class="table-container">
          {{ formatFieldName(field.name) }}
          <StoresCount v-if="!!item.competitorNames" :store-names="item.competitorNames" :is-competitor="true" @open-modal="$emit('open-modal', item.competitorNames)" />
          <router-link
            v-if="showReviewLink && itemIndex !== 'display0' && !hideReviewLinkForSpecificItem"
            :to="{
              name: 'CompaniesCompetitorsReviews',
              params: {
                company_uuid: companyUuid,
              },
              query: {
                analysis_type: adaptKey(item.fields[0].key),
                analysis_id: adaptId(item.fields[0]),
                cross_analysis_type: adaptKey(field.key),
                cross_analysis_id: adaptId(field)
              }
            }"
            class="review-link"
          >
            <KkIcon name="review" color="#D2D5DB" />
          </router-link>
        </div>
      </td>
    </template>
    <td v-for="head in staticHeads" :key="head.id" class="u-taR">
      <button v-if="activateClickItemFunction" :class="$style.activateClickItem" @click="$emit('click-item', { id: head.id, item })">
        {{ item[head.id] !== null ? valueFormatter(item[head.id]) : '-' }}
      </button>
      <template v-else>{{ item[head.id] !== null ? valueFormatter(item[head.id]) : '-' }}</template>
      <span class="compare-value" :class="compareValueColor(item[head.id], compareItem[head.id])">({{ compareItemValues(item[head.id], compareItem[head.id]) }})</span>
    </td>
  </tr>
</template>

<script>
import StoresCount from '../StoresCount'
import { toNumberLocaleString } from '../../../modules/localeString'
import { KkIcon } from '../../../components/base'
import { generateGraphId } from '../../../modules/analysis'

export default {
  name: 'CompetitorTableRow',
  components: {
    StoresCount,
    KkIcon,
  },
  props: {
    compareItem: {
      type: Object,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
    itemIndex: {
      type: String,
      required: true,
    },
    searchItems: {
      type: Array,
      required: false,
    },
    staticHeads: {
      type: Array,
      required: true,
    },
    truncateStoreName: {
      type: Boolean,
      default: false,
    },
    analysisAxisField: {
      type: Object,
      required: true,
    },
    maxSelectableXAxesNum: {
      type: Number,
      default: null,
    },
    showReviewLink: {
      type: Boolean,
      default: false,
    },
    showTableRowIndex: {
      type: Boolean,
      default: true,
    },
    valueFormatter: {
      type: Function,
      required: true,
    },
    activateClickItemFunction: {
      type: Boolean,
      default: false,
    }
  },
  emits: ['open-modal', 'change-display-graphs', 'click-item'],
  computed: {
    companyUuid() {
      return this.$route.params.company_uuid
    },
    displayCheckbox() {
      return !!this.searchItems
    },
    // 特定のレコードは口コミ一覧の絞り込みに対応してないためリンクを出さない
    hideReviewLinkForSpecificItem() {
      // 言語別の軸で未分類(-1)のものは口コミ一覧で絞り込みできないため
      return this.item.fields.some(field => field.key === 'locale' && field.id === '-1')
    },
    innerSearchItems: {
      get() {
        return this.searchItems
      },
      set(val) {
        this.$emit('change-display-graphs', val)
      }
    },
  },
  methods: {
    formatGraphId(item) {
      return generateGraphId(item)
    },
    compareItemValues(value, target) {
      if (value === '-' || target === '-') return '-'
      // ieee754に抗う
      let diff = value * 10000 - target * 10000
      diff /= 10000

      if (diff > 0) {
        diff = '+' + diff
      }
      return String(diff)
    },
    compareValueColor(value, target) {
      let colorClassName = 'equal-color'
      if (value > target) {
        colorClassName = 'plus-color'
      } else if(value < target) {
        colorClassName = 'minus-color'
      }
      return colorClassName
    },
    formatFieldName(name) {
      if (this.analysisAxisField.id !== 'store' && this.analysisAxisField.id !== 'brand') {
        return this.$t('pages.companies.analysis.table.competitorRow', { name: name })
      }
      return name
    },
    /**
     * 数値の3桁区切り
     * @param  { Number } value
     * @return { Number }
     */
    numberLocaleString(value) {
      return toNumberLocaleString(value)
    },
    hasMaxSelectableXAxesNum() {
      return this.maxSelectableXAxesNum != null
    },
    adaptKey(key) {
      switch(key) {
      case('competitor_id'):
        return 'stores'
      case('site_type'):
        return 'sites'
      case('competitor_brand_id'):
        return 'brands'
      case('franchisee_id'):
        return 'franchisees'
      case('user_company_id'):
        return 'user_companies'
      case('prefecture'):
        return 'prefectures'
      case('area_id'):
        return 'areas'
      case('locale'):
        return 'locales'
      case('original_tag_group_a_tag_id'):
        return 'original_tag_group_a'
      case('original_tag_group_b_tag_id'):
        return 'original_tag_group_b'
      case('original_tag_group_c_tag_id'):
        return 'original_tag_group_c'
      case('original_tag_group_d_tag_id'):
        return 'original_tag_group_d'
      case('original_tag_group_e_tag_id'):
        return 'original_tag_group_e'
      default:
        return key
      }
    },
    adaptId(field) {
      let currentCompareField
      switch(field.key) {
      case('competitor_id'):
        currentCompareField = this.compareItem.fields.find(field => field.key === 'store_id')
        return currentCompareField.uuid
      case('competitor_brand_id'):
        currentCompareField = this.compareItem.fields.find(field => field.key === 'brand_id')
        return currentCompareField.id
      default:
        return field.id
      }
    },
  }
}
</script>

<style lang="scss" module>
.activateClickItem {
  text-decoration: underline;
}
</style>

<style lang="scss" scoped>
@import '../../../../../stylesheets/biz_spa/foundation/_var.scss';

.competitor-tr td {
  padding-top: 7.5px;
  padding-bottom: 7.5px;
  background: $color-competitor-bg;
  color: $color-base-a;
}
.competitor-tr__name-box {
  display: flex;
}
.competitor-tr__name {
  margin: auto 0;
  color: $color-base-a;
}
.competitor-badge {
  margin-left: 8px;
  background: $color-base-a;
  border-radius: 12px;
  color: $color-font-base;
  padding: 4px 6px;
  text-align: center;
  width: 32px;
  font-size: 10px;
}
.equal-color {
  color: $color-base-a;
}
.minus-color {
  color: $color-base-a;
}
.plus-color {
  color: $color-base-a;
}
.compare-value {
  display: block;
  font-size: 10px;
}
.index-number {
  font-weight: bold;
  margin: 0 17px;
}
.table-container {
  display: flex;
  align-items: center;
}
.review-link {
  width: 24px;
  margin-left: auto;
  padding-left: 8px;
}
</style>
